var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 9.99997L16.59 8.58997L12 13.17L7.41 8.58997L6 9.99997L12 16L18 9.99997Z","fill":"currentColor"}));
}

ChevronDown.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
